import {useMemo, useRef} from 'react';
import useIntersection from './useIntersection';
import Loading from '../component/Loading';
import {useFetchInfo} from '../util/fetch';

interface IProps {
  actionType: string;
  fetchKey?: string;
  isEnd?: boolean;
  requestGetNextList: () => void;
  disabled?: boolean;
}

export default function useFetchNextList({
  actionType,
  fetchKey,
  isEnd: _isEnd,
  requestGetNextList,
  disabled,
}: IProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {isFirstFetched, isEnd} = useFetchInfo(actionType, fetchKey);
  const isNextEnd = _isEnd || isEnd;

  useIntersection(
    {
      targetRef: ref,
      options: OPTIONS,
      onIntersection: isIntersecting => {
        !disabled && isIntersecting && requestGetNextList();
      },
    },
    isNextEnd || !isFirstFetched
  );

  const NextLoading = useMemo(
    () => () => (
      <>
        {!disabled && !isNextEnd && isFirstFetched && (
          <div ref={ref} className="w-full relative py-10 flex-center">
            <Loading />
          </div>
        )}
      </>
    ),
    [isNextEnd, isFirstFetched, disabled]
  );

  return {NextLoading};
}

const OPTIONS = {rootMargin: '100px 0px'};
